import {defer, map, Subject} from 'rxjs';
import {legendTradingApi} from '@/api/legend-trading';
import {createPollObservable} from '@/streams/utils';
import {LEGEND_KYC_STATUS_DATA} from '../utils';

export const LoadLegendKYCStatusPollTimes = 6;
export const stopLoadLegendKYCStatus$ = new Subject<void>();
export const {poll$: legendKYCStatus$, notifier$: loadLegendKYCStatus$} = createPollObservable(
  () =>
    defer(legendTradingApi.getKycApprovedStatusV2).pipe(
      map((response) => {
        const {data, error} = response;
        if (!!data) {
          return 'APPROVED';
        }
        return LEGEND_KYC_STATUS_DATA[error?.code] || LEGEND_KYC_STATUS_DATA.PROCESSING;
      })
    ),
  {
    pollInterval: 2000,
    pollTimes: LoadLegendKYCStatusPollTimes,
  }
);
